import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ikImage from "../assets/ik.jpeg";
import ik2Image from "../assets/jhh.png";

const Hero = () => {
  const [particles, setParticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const newParticles = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      style: {
        '--tx': `${Math.random() * 100 - 50}vw`,
        '--ty': `${Math.random() * 100 - 50}vh`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 20}s`,
        opacity: Math.random() * 0.2 + 0.1,
        width: `${Math.random() * 6 + 2}px`,
        height: `${Math.random() * 6 + 2}px`,
      }
    }));
    setParticles(newParticles);
  }, []);

  const handleClaimClick = () => {
    const claimSection = document.getElementById('claim');
    if (claimSection) {
      claimSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleExploreEcosystem = () => {
    const ecosystemSection = document.getElementById('ecosystem');
    if (ecosystemSection) {
      ecosystemSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const ecoSection = document.getElementById('ecosystem');
        if (ecoSection) {
          ecoSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <section className="min-h-screen relative overflow-hidden bg-gradient-hero">
      {particles.map(particle => (
        <div
          key={particle.id}
          className="particle"
          style={particle.style}
        />
      ))}

      <div className="absolute top-20 left-10 w-20 h-20 bg-eco-green rounded-full opacity-10 blur-xl floating"></div>
      <div className="absolute top-40 right-20 w-16 h-16 bg-eco-blue rounded-full opacity-15 blur-xl floating" style={{animationDelay: '2s'}}></div>
      <div className="absolute bottom-40 left-20 w-24 h-24 bg-eco-purple rounded-full opacity-10 blur-xl floating" style={{animationDelay: '4s'}}></div>

      <div className="max-w-7xl mx-auto px-8 py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8 slide-in">
            <div className="space-y-6">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-20 h-17 rounded-2xl overflow-hidden border-2 border-white/50">
                  <img 
                    src={ik2Image} 
                    alt="X EcoChain Green Mode" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h1 className="text-4xl font-black gradient-text">X ECOCHAIN</h1>
                  <div className="eco-badge">White Mode</div>
                </div>
              </div>

              <div className="relative">
                <h1 className="text-5xl lg:text-6xl font-black leading-tight">
                  <span className="gradient-text">THE WORLD</span>
                  <br />
                  <span className="text-white">IS BECOMING</span>
                  <br />
                  <span className="gradient-text">TOKENIZED</span>
                </h1>
                
                <div className="grid grid-cols-3 gap-3 mt-6 max-w-md">
                  <div className="text-center p-3 glass-card rounded-xl hover:transform hover:scale-105 transition-all duration-300">
                    <div className="text-2xl mb-1">🚗</div>
                    <div className="text-sm font-semibold text-white">CAR</div>
                  </div>
                  <div className="text-center p-3 glass-card rounded-xl hover:transform hover:scale-105 transition-all duration-300">
                    <div className="text-2xl mb-1">🥇</div>
                    <div className="text-sm font-semibold text-gray-300">GOLD</div>
                  </div>
                  <div className="text-center p-3 glass-card rounded-xl hover:transform hover:scale-105 transition-all duration-300">
                    <div className="text-2xl mb-1">🎓</div>
                    <div className="text-sm font-semibold text-gray-400">DIPLOMA</div>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-xl text-gray-300 leading-relaxed">
              X EcoChain is pioneering the green blockchain revolution. 
              Sustainable, efficient, and built for the future of decentralized tokenization.
            </p>

            <div className="flex items-center space-x-4">
              <div className="tooltip" data-tooltip="Each node runs on less energy than an LED bulb. Proof that decentralization can be sustainable.">
                <div className="flex items-center space-x-2 text-white cursor-help">
                  <span>🌿</span>
                  <span className="font-semibold">Eco-Powered</span>
                  <span>ℹ️</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={handleClaimClick}
                className="btn-eco px-8 py-4 text-lg font-bold hover:scale-105 transition-transform duration-300"
              >
                Claim Your Share
              </button>
              <button 
                onClick={handleExploreEcosystem}
                className="btn-secondary px-8 py-4 text-lg font-bold hover:scale-105 transition-transform duration-300"
              >
                Explore X1 Ecosystem
              </button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-2xl font-black gradient-text">2.4M+</div>
                <div className="text-gray-400 text-sm">Transactions</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-black gradient-text">98%</div>
                <div className="text-gray-400 text-sm">Energy Efficient</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-black gradient-text">50K+</div>
                <div className="text-gray-400 text-sm">Active Users</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="glass-card p-6 rounded-3xl transform rotate-3 hover:rotate-0 transition-transform duration-500 overflow-hidden">
              <div className="bg-gradient-eco p-1 rounded-2xl">
                <div className="bg-eco-black rounded-2xl overflow-hidden">
                  <img 
                    src={ikImage} 
                    alt="The World is Becoming Tokenized" 
                    className="w-full h-64 object-cover opacity-90 hover:opacity-100 transition-opacity duration-300"
                  />
                  <div className="p-6">
                    <div className="text-center space-y-4">
                      <div className="w-16 h-16 bg-gradient-eco rounded-2xl mx-auto flex items-center justify-center text-eco-black text-xl font-black">
                        X1
                      </div>
                      <h3 className="text-2xl font-black gradient-text">ECO TOKEN</h3>
                      <p className="text-gray-300 text-sm">Sustainable blockchain powered by proof-of-authority consensus</p>
                      <div className="grid grid-cols-2 gap-4 pt-4">
                        <div className="text-center">
                          <div className="text-white font-bold">0.002 kWh</div>
                          <div className="text-gray-400 text-xs">Per Transaction</div>
                        </div>
                        <div className="text-center">
                          <div className="text-gray-300 font-bold">2.1s</div>
                          <div className="text-gray-400 text-xs">Avg. Block Time</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 bg-gradient-eco text-eco-black px-4 py-2 rounded-full font-bold text-sm transform rotate-12 glow">
              ⚪ WHITE MODE
            </div>
            <div className="absolute -bottom-4 -left-4 bg-eco-blue text-eco-black px-4 py-2 rounded-full font-bold text-sm transform -rotate-12">
              ⚡ LOW ENERGY
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;